<script>
import loraSvg from "@/assets/icons/technologies/icon_lora.svg"
import mqttSvg from "@/assets/icons/technologies/icon_mqtt.svg"
import udpSvg from "@/assets/icons/technologies/icon_udp.svg"
import httpSvg from "@/assets/icons/technologies/icon_http.svg"
import { mapActions, mapState } from "vuex"

export default {
  name: "DataFlowDiagramTechnology",

  emits: ["change"],
  props: {
    dataFlow: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    isKebabOpened: false
  }),
  computed: {
    ...mapState({
      serviceList: (state) => state.services.services
    }),
    selectedTechnology() {
      return this.technologyOptions.find((t) => t.id === this.dataFlow.technology)
    },
    technologyOptions() {
      return [
        {
          title: this.$t("LORA_TECH"),
          image: loraSvg,
          description: this.$t("LORA_DESCRIPTION_FOR_DATA_FLOW"),
          id: "LORA"
        },
        {
          title: this.$t("MQTT"),
          image: mqttSvg,
          description: this.$t("MQTT_DESCRIPTION_FOR_DATA_FLOW"),
          id: "MQTT"
        },
        {
          title: this.$t("UDP"),
          image: udpSvg,
          description: this.$t("UDP_DESCRIPTION_FOR_DATA_FLOW"),
          id: "UDP",
          disabled: this.serviceList.length
            ? !this.serviceList.filter((s) => s.enabled && !s.suspended && s.productElementId === "s_iot2293").length
            : true
        },
        {
          title: this.$t("HTTP"),
          image: httpSvg,
          description: this.$t("HTTP_DESCRIPTION_FOR_DATA_FLOW"),
          id: "HTTP",
          disabled: true
        }
      ]
    }
  },
  async created() {
    await this.getServiceList()
  },
  methods: {
    ...mapActions({
      getServiceList: "services/getServices"
    })
  }
}
</script>

<template>
  <div class="data-flow-diagram__box">
    <div class="data-flow-diagram__box__header">
      {{ $t("TECHNOLOGY") }}
    </div>
    <div v-if="!selectedTechnology">
      <div
        v-for="technology in technologyOptions"
        :key="`techDiv${technology.id}`"
        class="data-flow-diagram__box__option cursor-pointer position-relative"
        @click="!technology.disabled ? $emit('change', technology.id) : () => {}"
      >
        <div v-if="technology.disabled" class="position-absolute disabled-text w-100 h-100 text-danger">
          <strong>{{ $t("TECHNOLOGY_NOT_AVAILABLE") }}</strong>
        </div>
        <div class="option-wrapper" :class="{ disabled: technology.disabled }">
          <div>
            <div class="data-flow-diagram__box__option__header">
              <img :src="technology.image" alt="" />
              <h6 class="mb-0">
                {{ technology.title }}
              </h6>
            </div>
          </div>
          <div :class="{ hidden: technology.disabled }">
            {{ technology.description }}
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="data-flow-diagram__box__option">
        <div class="d-flex justify-content-between">
          <div class="data-flow-diagram__box__option__header">
            <img :src="selectedTechnology.image" alt="" />
            <h6 class="mb-0">
              {{ selectedTechnology.title }}
            </h6>
          </div>
          <div v-if="!readonly" class="dropdown-actions">
            <div class="atom-icon d-block mr-0" @click="isKebabOpened = true">
              <img height="32" src="@/assets/icons/menu/ico-kebab.svg" />
            </div>
            <div
              v-if="isKebabOpened"
              v-click-outside="
                () => {
                  isKebabOpened = false
                }
              "
              class="dropdown-actions__wrapper"
            >
              <div class="dropdown-actions__inner">
                <div
                  class="dropdown-actions__item d-flex align-items-center"
                  @click="
                    () => {
                      $emit('change', null)
                      isKebabOpened = false
                    }
                  "
                >
                  <div class="atom-icon">
                    <img alt="" src="@/assets/icons/ico-upravitzarizeni.svg" />
                  </div>
                  {{ $t("CHANGE") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
